export default "__VITE_ASSET__goIRrvJe__"